import { TimerService } from "./../timer/timer.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { OnInit } from "@angular/core";
import { Component } from "@angular/core";

@Component({
    selector: "app-start-with-ongoing-entry-modal",
    templateUrl: "./start-with-ongoing-entry-modal.component.html",
    styleUrls: ["./start-with-ongoing-entry-modal.component.scss"],
    standalone: true,
})
export class StartWithOngoingEntryModalComponent implements OnInit {
  jobName: string;
  company: string;

  public onClose: Subject<boolean>;

  constructor(
    public bsModalRef: BsModalRef,
    private timerService: TimerService
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  cancel() {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
  confirm() {
    this.timerService.timerStop();
    this.onClose.next(true);
    this.bsModalRef.hide();
  }
}
